import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SelectedPanelEnum } from '@app/core';
import { InsurancesQueryParamsInterface } from '@app/my-zone/interfaces/insurances-query-params.interface';
import {
    ErrorInterface,
    InsurancePolicyActionService,
    NewModal,
    PolicyValidityStatusCodeEnum,
    PurchasedProductInterface,
} from 'outshared-lib';
import { filter } from 'rxjs/operators';
import { InsuranceRegularDriverModal } from '../insurance-regular-driver-modal';

@Component({
    selector: 'ins-insurance-regular-driver-future',
    templateUrl: './insurance-regular-driver-future.component.html',
    styleUrls: ['./insurance-regular-driver-future.component.scss']
})
export class InsuranceRegularDriverFutureComponent {

    @Input() public purchasedProduct!: PurchasedProductInterface;

    public errors: ErrorInterface[];
    public isDisabled: boolean;

    constructor(
        private insurancePolicyActionService: InsurancePolicyActionService,
        private router: Router,
        private changeDetectorRef: ChangeDetectorRef,
        private modalService: NewModal,
    ) {
        this.errors = [];
        this.isDisabled = false;
    }

    public get regularDriverFutureName(): string {
        return `
            ${this.purchasedProduct?.productDetails?.regularDriverFuture?.genderDescription}
            ${this.purchasedProduct?.productDetails?.regularDriverFuture?.initials}
            ${this.purchasedProduct?.productDetails?.regularDriverFuture?.middleNameInitials}
            ${this.purchasedProduct?.productDetails?.regularDriverFuture?.surname}
        `;
    }

    public get hasRegularDriverFuture(): boolean {
        return Boolean(this.purchasedProduct?.productDetails?.regularDriverFuture);
    }

    public get isPolicyHolder(): boolean {
        return Boolean(
            this.purchasedProduct?.productDetails?.regularDriver?.endDate &&
            !this.purchasedProduct?.productDetails?.regularDriverFuture);
    }

    public get isActiveProduct(): boolean {
        return [
            PolicyValidityStatusCodeEnum.Active,
            PolicyValidityStatusCodeEnum.ActiveChange,
        ].includes(this.purchasedProduct?.product?.validityStatusCode);
    }

    public openInsuranceRegularDriverModal(): void {
        this.modalService
            .open(InsuranceRegularDriverModal)
            .afterClosed$()
            .pipe(filter((_response) => Boolean(_response.cancel)))
            .subscribe({
                next: () => this.onCancelAddedRegularDriver(),
            });
    }

    private onCancelAddedRegularDriver(): void {
        this.insurancePolicyActionService
            .cancelAddedRegularDriver$({
                productId: this.purchasedProduct.productId,
                productSequenceNumber: this.purchasedProduct.productSequenceNumber,
            })
            .subscribe({
                next: () => this.cancelAddedRegularDriverSuccess(),
                error: (errors) => this.cancelAddedRegularDriverError(errors),
            });

        this.errors = [];
        this.isDisabled = true;
    }

    private cancelAddedRegularDriverSuccess(): void {
        this.isDisabled = false;
        this.errors = [];
        this.closePanel();
        this.changeDetectorRef.detectChanges();
    }

    private closePanel(): void {
        const queryParams: InsurancesQueryParamsInterface = {
            panel: SelectedPanelEnum.Close,
            productId: this.purchasedProduct.productId,
            productSequenceNumber: this.purchasedProduct.productSequenceNumber,
            scroll: true,
        };

        this.router.navigate([], {
            queryParams,
            queryParamsHandling: 'merge',
        });
    }

    private cancelAddedRegularDriverError(errors: ErrorInterface[]): void {
        this.errors = errors;
        this.isDisabled = false;
    }
}
